import React, { useEffect } from 'react'
import Container from "../../components/Container/Container"
import Document from '../../components/Documents/Document'
import { getDocument, userSelector } from '../../services/reduxSlices/UserSlice';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Page du menu Boite de reception --> Document en attente de signature
 * @returns SignDocs
 */
export default function WaitingDocs() {

  const FilterWaitingDoc = (data) => {
    const waitingDocs = data.filter((doc) => doc.statut === 'en_attente')
    return waitingDocs
  }

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getDocument())
  }, [])

  const { signDocuments } = useSelector(userSelector)

  useEffect(() => {
    let script = document.createElement("script")
    script.src = "./assets/js/scripts.bundle.js"
    document.body.appendChild(script)
  }, [])

  return (
    <Container>
       {
          signDocuments.data &&
          <>
            <h1 style={{color:'wheat', fontWeight:'700'}}>Document en attende de signature ({FilterWaitingDoc(signDocuments.data).length})</h1>
            <Document data={FilterWaitingDoc(signDocuments.data)} /> 
          </>
        }
    </Container>
  )
}
